import { useEffect, useState } from 'react';

import { DateTime } from 'luxon';

interface LastSavedTimeIndicatorProps {
  lastSavedTime: DateTime | null;
}
/**
 * UI Component to update last auto saved time, relative to now every 5 seconds.
 */
const LastSavedTimeIndicator = ({
  lastSavedTime,
}: LastSavedTimeIndicatorProps) => {
  const [_, setRerenderTrigger] = useState(false);
  const [intervalId, setIntervalId] = useState<ReturnType<
    typeof setInterval
  > | null>(null);

  useEffect(() => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setIntervalId(
      setInterval(() => {
        setRerenderTrigger((prev) => !prev);
      }, 1000 * 5),
    );
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [lastSavedTime]);

  if (!lastSavedTime) {
    return <></>;
  }

  return <>{`Auto-saved ${lastSavedTime.toRelative()}`}</>;
};

export default LastSavedTimeIndicator;
